import API from "$vueCommon/classes/API.js";
import bus from "vue3-eventbus";
import { reactive, toRefs } from 'vue';

const managerBaseUrl = '/manager';

export default class CartAPI extends API {

    static loading = false;
    static rowLoading = {};
    static baseUrl = '';

    static setManagerBaseUrl() {
        this.baseUrl = managerBaseUrl;
    }

    static content() {
        return this.get(this.baseUrl + '/api/cart/content').then(response => response.data);
    }
    
    static postDiscountCode(discountCode) {
        console.log('pdc', this.baseUrl);
        return new Promise((resolve, reject) => {
            this.post(this.baseUrl + '/api/cart/discount-code', {discount_code: discountCode}).then(response => {
                resolve(response);
                bus.emit('refreshCart', {data: response});
            }, errorResponse => {
                reject(errorResponse);
            });
        });
    }

    static period(rowId, period) {
        return new Promise((resolve, reject) => {
            this.post(this.baseUrl + '/api/cart/period/' + rowId, {period: period}, rowId).then(response => {
                resolve(response);
                bus.emit('refreshCart', {data: response, rowId: rowId});
            });
        });
    }

    static remove(rowId) {
        return new Promise((resolve, reject) => {
            this.post(this.baseUrl + '/api/cart/remove/' + rowId, null, rowId).then(response => {
                resolve(response);
                bus.emit('refreshCart', {data: response, rowId: rowId});
            });
        });
    }

    static idProtect(rowId, status = false) {
        return new Promise((resolve, reject) => {
            this.post(this.baseUrl + '/api/cart/id-protect/' + rowId, {status: status === true ? 'true' : 'false'}, rowId).then(response => {
                resolve(response);
                bus.emit('refreshCart', {data: response, rowId: rowId});
            });
        });
    }

    static post(url, data = null, rowId = null) {
        this.loading = true;
        if (rowId) {
            this.rowLoading[rowId] = true;
        }

        return new Promise((resolve, reject) => {
            super.post(url, data).then(
                response => {
                    this.loading = false;
                    if (rowId) {
                        this.rowLoading[rowId] = false;
                    }

                    resolve(response.data);
                },
                errorResponse => {
                    this.loading = false;
                    if (rowId) {
                        this.rowLoading[rowId] = false;
                    }

                    reject(errorResponse);
                }
            );
        });
    }
}
